import { useEffect, useState } from 'react';
import { MultiplexedChannel } from 'infrastructure/t4/ChannelResolver/MultiplexedChannel';
import { cancellable } from '../utility/cancellable';

export function useMultipleChannelStreams(channel: MultiplexedChannel | undefined, audio: boolean) {
    const [streams, setStreams] = useState<(MediaStream | undefined)[]>(() => {
        if (!channel) return [];
        return channel.channels.map(() => undefined);
    });

    useEffect(() => {
        if (!channel) return;

        const streams: (MediaStream | undefined)[] = channel.channels.map(() => undefined);

        const listener = (stream: MediaStream, index: number) => {
            streams[index] = stream;
            setStreams([...streams]);
        };

        channel.addReconnectListener(listener);

        return cancellable(async isCanceled => {
            try {
                await channel.connect({ audio });
                if (isCanceled()) return;
            } catch (e) {
                console.error(`error while connecting media stream: ${JSON.stringify(e)}`);
                // TODO: error handling
            }
        }, () => {
            channel.disconnect();
            channel.removeReconnectListener(listener);
        });
    }, [channel, audio]);

    return streams;
}
